/* eslint-disable react-hooks/exhaustive-deps */
import {useMemo} from 'react'

import {FIELD_NAME} from './config.js'

const useOptions = ({from, to, value}) => {
  const defaultOptions = useMemo(
    () => ({
      [FIELD_NAME.FROM]: from.options,
      [FIELD_NAME.TO]: to.options
    }),
    [from, to]
  )

  const currentOptions = useMemo(
    () => ({
      [FIELD_NAME.FROM]: value.to
        ? defaultOptions[FIELD_NAME.FROM].filter(({id}) => id <= value.to)
        : defaultOptions[FIELD_NAME.FROM],
      [FIELD_NAME.TO]: value.from
        ? defaultOptions[FIELD_NAME.TO].filter(({id}) => id >= value.from)
        : defaultOptions[FIELD_NAME.TO]
    }),
    [from, to, value]
  )

  return {options: currentOptions}
}

export default useOptions
